import React, { useState } from 'react';
import {
  BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO,
  BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO
} from '../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import PrintableModal from '../../../../components/PrintableModal';
import { BondInsuranceHiredDataForGetCompleteBondInsurancePolicyByIdResponseDTO } from '../../../../dtos/bond-insurance-policy-list/get-complete-bond-insurance-policy-by-id-response.dto';
import { Button, Grid, Popup, Icon, Tab } from 'semantic-ui-react';
import { BondInsuranceProposalMainInfoDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/BondInsuranceProposalMainInfoDetails';
import { BondInsuranceMainInfoDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/BondInsuranceMainInfoDetails';
import { BondInsurancePropertyDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/BondInsurancePropertyDetails';
import { PersonTypesEnum } from '../../../../enums/person-types.enum';
import { BondInsuranceNaturalTenantDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/BondInsuranceNaturalTenantDetails';
import { BondInsuranceLegalTenantDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/BondInsuranceLegalTenantDetails';
import { ComboTooFireInsurancePoliciesListResponseDTO } from '../../../../dtos/bond-insurance-policy-list/interfaces/policy-for-get-bond-insurance-policies-list-response-dto';
import { ComboFireInsuranceDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/ComboFireInsuranceDetails';
import { BondInsuranceOwnerDetails } from '../../../bond-insurance-proposal-list/components/proposal-details/components/BondInsuranceOwnerDetails';
import { BondInsurancePolicyMainInfoDetails } from './components/BondInsurancePolicyMainInfoDetails';
import { downloadLetter, sendAnyLetter } from '../../../../services/bond-insurance';
import {
  dangerNotification,
  successNotification
} from '../../../../services/notification';
import { UserRolesEnum } from '../../../../enums/user-roles.enum';
import LogModal from '../../../../components/LogModal/LogModal';
import { get } from '../../../../services/storage';
import AuthorizationContainer from '../../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../../enums/authz-feature.enum';
import { BondInsuranceHiredDataStatusEnum } from '../../../../enums/bond-insurance-hired-data-status.enum';
import RelatedPoliciesTable from './components/RelatedPoliciesTable';

type SectionContainerProps = {
  title: string;
  children: React.ReactNode;
};

const SectionContainer: React.FC<SectionContainerProps> = ({ title, children }) => (
  <div
    style={{
      border: '1px solid #e0e0e0',
      borderRadius: '4px',
      padding: '16px',
      marginBottom: '16px'
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }}
    >
      <Icon name="chevron right" />
      <span
        style={{
          fontWeight: 'bold',
          fontSize: '1.1em',
          marginLeft: '8px'
        }}
      >
        {title}
      </span>
    </div>
    {children}
  </div>
);

export type Props = {
  combo?: ComboTooFireInsurancePoliciesListResponseDTO | null;
  bondInsurance: BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO | null;
  bondInsuranceAnalysis: BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO | null;
  bondInsuranceHiredData: BondInsuranceHiredDataForGetCompleteBondInsurancePolicyByIdResponseDTO | null;
  isOpen: boolean;
  onClose: React.ReactEventHandler<{}>;
  bondInsuranceId?: string;
  callback: Function;
  getPrevious: Function;
};

export const BondInsurancePolicyDetails = (props: Props) => {
  const {
    bondInsurance,
    bondInsuranceAnalysis,
    bondInsuranceHiredData,
    isOpen,
    onClose,
    combo,
    bondInsuranceId,
    callback,
    getPrevious
  } = props;
  const [loadingMail, setLoadingMail] = useState(false);
  const [loadingDownloadFile, setLoadingDownloadFile] = useState(false);
  const [openLogModal, setOpenLogModal] = useState(false);

  const close = (): void => {
    setOpenLogModal(false);
  };

  const userRole = get('role');

  const panes = [
    {
      menuItem: 'Geral',
      render: () => (
        <Tab.Pane attached={false}>
          {bondInsurance && bondInsuranceAnalysis && bondInsuranceHiredData && (
            <Grid>
              {bondInsuranceHiredData.code === 'QUIVER' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <br />
                  <br />
                  <p> Atenção: Apólice importada automaticamente de sistema externo.</p>
                </div>
              )}
              <Grid.Row>
                <Grid.Column width={16}>
                  <SectionContainer title="DADOS DA APÓLICE">
                    <BondInsurancePolicyMainInfoDetails
                      bondInsuranceHiredData={bondInsuranceHiredData}
                      bondInsuranceAnalysis={bondInsuranceAnalysis}
                      getPreviousHired={getPrevious}
                    />
                  </SectionContainer>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <SectionContainer title="DADOS DA PROPOSTA">
                    <Grid style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                      <BondInsuranceProposalMainInfoDetails
                        bondInsuranceAnalysis={bondInsuranceAnalysis}
                        hiredData={bondInsuranceHiredData}
                      />
                    </Grid>
                  </SectionContainer>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <SectionContainer title="DADOS DA ANÁLISE">
                    <Grid style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                      <BondInsuranceMainInfoDetails
                        bondInsurance={bondInsurance}
                        bondInsuranceAnalysis={bondInsuranceAnalysis}
                      />
                    </Grid>
                  </SectionContainer>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <SectionContainer title="DADOS DO PROPRIETÁRIO">
                    <Grid style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                      <BondInsuranceOwnerDetails bondInsurance={bondInsurance} />
                    </Grid>
                  </SectionContainer>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <SectionContainer title="DADOS DO IMÓVEL">
                    <Grid style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                      <BondInsurancePropertyDetails bondInsurance={bondInsurance} />
                    </Grid>
                  </SectionContainer>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <SectionContainer title="DADOS DO LOCATÁRIO">
                    <Grid style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                      {bondInsurance.tenantType === PersonTypesEnum.natural && (
                        <BondInsuranceNaturalTenantDetails
                          bondInsurance={bondInsurance}
                        />
                      )}
                      {bondInsurance.tenantType === PersonTypesEnum.legal && (
                        <BondInsuranceLegalTenantDetails bondInsurance={bondInsurance} />
                      )}
                    </Grid>
                  </SectionContainer>
                </Grid.Column>
              </Grid.Row>
              {combo !== null && (
                <Grid.Row>
                  <Grid.Column width={16}>
                    <SectionContainer title="SEGURO INCÊNDIO (COMBO)">
                      <ComboFireInsuranceDetails combo={combo!} />
                    </SectionContainer>
                  </Grid.Column>
                </Grid.Row>
              )}
            </Grid>
          )}
        </Tab.Pane>
      )
    },
    {
      menuItem: 'Apólices Relacionadas',
      render: () => (
        <Tab.Pane attached={false}>
          <RelatedPoliciesTable
            estateId={bondInsurance!.estate.id}
            document={
              bondInsurance?.naturalTenant?.main_tenant_cpf ||
              bondInsurance?.legalTenant?.document
            }
            hiredDataId={bondInsuranceHiredData!.id}
          />
        </Tab.Pane>
      )
    }
  ];

  return (
    <>
      {bondInsurance && bondInsuranceAnalysis && bondInsuranceHiredData && (
        <PrintableModal
          isOpen={isOpen}
          bondInsuranceId={bondInsuranceId}
          onClose={onClose}
          header={
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              Apólice de Seguro Fiança
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between'
                }}
              >
                {userRole === UserRolesEnum.brokerAdmin && (
                  <LogModal
                    setOpen={setOpenLogModal}
                    callback={callback}
                    closeModal={close}
                    analysisId={bondInsurance.id}
                    proposalId={bondInsuranceAnalysis.id}
                    policyId={bondInsuranceHiredData.id}
                    createdAt={bondInsurance.createdAt}
                  />
                )}
                <AuthorizationContainer
                  action={ActionEnum.send}
                  feature={FeatureEnum.letters}
                >
                  <Button
                    floated="left"
                    style={{ backgroundColor: '#59249B', color: 'white' }}
                    loading={loadingMail}
                    disabled={loadingMail}
                    onClick={async () => {
                      setLoadingMail(true);
                      try {
                        sendAnyLetter(bondInsuranceAnalysis.id);
                        successNotification('Sucesso', 'Carta enviada!');
                      } catch (e) {
                        dangerNotification(
                          'Oops...',
                          'Ocorreu um erro ao enviar a carta'
                        );
                      }
                      setLoadingMail(false);
                    }}
                  >
                    Reenviar carta de aprovação
                  </Button>
                </AuthorizationContainer>
                <AuthorizationContainer
                  action={ActionEnum.download}
                  feature={FeatureEnum.letters}
                >
                  <Popup
                    content={
                      'Clique para realizar o Download da carta de Aprovação e sua Cláusula!'
                    }
                    position={'top left'}
                    trigger={
                      <Button
                        icon="download"
                        style={{ backgroundColor: '#59249B', color: 'white' }}
                        loading={loadingDownloadFile}
                        onClick={async () => {
                          try {
                            setLoadingDownloadFile(true);
                            await downloadLetter(
                              bondInsuranceAnalysis.id,
                              bondInsurance.naturalTenant
                                ? bondInsurance.naturalTenant.main_tenant_name
                                : bondInsurance.legalTenant.company
                            );
                            successNotification(
                              'Sucesso',
                              'Download realizado com sucesso!'
                            );
                          } catch (e) {
                            dangerNotification(
                              'Oops...',
                              'Ocorreu um erro ao realizar o download carta'
                            );
                          } finally {
                            setLoadingDownloadFile(false);
                          }
                        }}
                      ></Button>
                    }
                  />
                </AuthorizationContainer>
              </div>
            </div>
          }
          content={<Tab menu={{ secondary: true, pointing: true }} panes={panes} />}
          disabled={
            userRole?.includes('ESTATE') &&
            bondInsuranceHiredData.status !==
              BondInsuranceHiredDataStatusEnum.underRenewal
          }
          callback={(): Promise<void | BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO> => {
            return {} as Promise<BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO>;
          }}
        />
      )}
    </>
  );
};
